<template>
  <div>
    <form>
      <div class="mood-box">
        <div v-for="mood in moods" :key="mood.value" class="mood-selection-box">
          <input
            class="radio-style"
            type="radio"
            name="mood"
            :value="mood.value"
            v-model="selectedMood"
            @input="handleRadioChange($event)"
          />
          <span 
            class="mood-text"
            :style="mood.value === 'christmas' ? { color: 'red' } : {}"
          >
            {{ lang === 'en' ? mood.labelEN : mood.labelKO }}
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoodSelector',
  props: {
    lang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedMood: null,
      moods: [
        { value: 'happy', labelEN: 'Happy', labelKO: '행복' },
        { value: 'moody', labelEN: 'Moody', labelKO: '분위기 있는' },
        // { value: 'christmas', labelEN: 'Christmas!', labelKO: '크리스마스' },
        { value: 'winter', labelEN: 'Winter', labelKO: '겨울' },
        { value: 'sad', labelEN: 'Sad', labelKO: '슬픈' },
        { value: 'rain', labelEN: 'Rain', labelKO: '비오는 날씨' },
        { value: 'dynamic', labelEN: 'Dynamic', labelKO: '다이나믹' }
      ]
    }
  },
  methods: {
    async handleRadioChange(event) {
      this.selectedMood = event.target.value
      this.$emit('selection', {
        mood: this.selectedMood,
        moodEN: this.getMoodLabel(this.selectedMood, 'en'),
        moodKO: this.getMoodLabel(this.selectedMood, 'ko')
      })
    },
    getMoodLabel(value, language) {
      const mood = this.moods.find(m => m.value === value)
      return language === 'en' ? mood.labelEN : mood.labelKO
    }
  }
}
</script>

<style scoped>
.mood-box {
  display: grid;
  grid-template-columns: auto auto auto;
  border-radius: 25px;
  border: 3px solid black;
  width: 480px;
  height: 190px;
  padding: 10px;
}

.mood-selection-box {
display: flex;
align-items: center;
}
.radio-style {
width: 30px;
height: 30px;
border: 1px;

}
.generate-btn {
  position: absolute;
  top: 310px;
  left: 100px;
}
</style>
